import React, { useState } from "react";
import { Form, Button, Input, Typography, message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { UserLogin } from "../../Api/CoreApi";
import {
  UserOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
  LoginOutlined,
  CrownOutlined,
  CodeOutlined,
  HeartFilled,
} from "@ant-design/icons";

const { Title, Text } = Typography;

function AdminLogin() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // AdminLogin.jsx - submit function ke andar

  const submit = async (values) => {
    setIsLoading(true);
    try {
      localStorage.removeItem("user_gender");
      localStorage.removeItem("user_caste");
      localStorage.removeItem("cached_user_id");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("role");
      localStorage.removeItem("user_id");

      const payload = {
        username: values.username.trim(),
        password: values.password,
      };

      const response = await UserLogin(payload);

      if (!response?.token?.access) {
        message.error("❌ Invalid credentials");
        return;
      }

      const role = (response.role || "").toLowerCase();
      const allowedRoles = ["admin", "superadmin", "developer", "dev"];

      if (!allowedRoles.includes(role)) {
        message.error("🚫 Access Denied! Only Admin & Developer can login here.");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        return;
      }

      // ⭐ Set all localStorage items
      localStorage.setItem("access_token", response.token.access);
      localStorage.setItem("refresh_token", response.token.refresh);
      localStorage.setItem("role", response.role);
      localStorage.setItem("user_id", response.user_id);
      localStorage.setItem("ref", response.refer || "");
      localStorage.setItem("username", response.username || values.username);

      if (role === "developer" || role === "dev") {
        message.success("💻 Welcome Developer!");
      } else {
        message.success("👑 Welcome Admin!");
      }

      // ⭐ FIX: Wait 200ms for localStorage to be fully set
      // Then navigate
      setTimeout(() => {
        navigate("/Admin_Panel");
      }, 200);

    } catch (err) {
      console.error("❌ Login Error:", err);
      const errorMsg =
        err.response?.data?.error ||
        err.response?.data?.details?.non_field_errors?.[0] ||
        "Login failed. Please try again.";
      message.error(`❌ ${errorMsg}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');

        * { font-family: 'Poppins', sans-serif !important; box-sizing: border-box; margin: 0; }

        .adm-login-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #ff0055 0%, #ff4d88 40%, #ff80aa 100%);
          padding: 20px;
          position: relative;
          overflow: hidden;
        }

        .adm-login-page::before {
          content: '';
          position: absolute;
          top: -20%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(255,255,255,.15) 0%, transparent 70%);
          border-radius: 50%;
          pointer-events: none;
        }

        .adm-login-page::after {
          content: '';
          position: absolute;
          bottom: -20%;
          left: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(255,255,255,.1) 0%, transparent 70%);
          border-radius: 50%;
          pointer-events: none;
        }

        .adm-particles {
          position: absolute;
          inset: 0;
          pointer-events: none;
          overflow: hidden;
          z-index: 1;
        }

        .adm-particle {
          position: absolute;
          animation: admFloat 4s ease-in-out infinite;
          opacity: 0.3;
        }

        @keyframes admFloat {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-25px) rotate(15deg); }
        }

        @keyframes admPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        @keyframes admShimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }

        /* ✅ CARD - Chauda banaya (wider) */
        .adm-login-card {
          width: 100%;
          max-width: 480px;
          background: #fff;
          border-radius: 24px;
          overflow: hidden;
          position: relative;
          z-index: 3;
          box-shadow: 0 24px 60px rgba(255,0,85,.3);
          animation: admCardIn 0.6s cubic-bezier(.4,0,.2,1);
        }

        @keyframes admCardIn {
          from { opacity: 0; transform: translateY(20px) scale(.96); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }

        .adm-top-bar {
          height: 4px;
          background: linear-gradient(90deg, #ff0055, #ff4d88, #ff80aa, #ff4d88, #ff0055);
          background-size: 200% 100%;
          animation: admShimmer 3s linear infinite;
        }

        /* ✅ HEADER - Compact (padding kam kiya) */
        .adm-card-header {
          padding: 20px 28px 14px;
          text-align: center;
          background: linear-gradient(180deg, #fff5f8 0%, #fff 100%);
        }

        /* ✅ LOGO - Chota kiya */
        .adm-logo-wrap {
          width: 56px;
          height: 56px;
          margin: 0 auto 10px;
          border-radius: 16px;
          background: linear-gradient(135deg, #ff0055, #ff4d88);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 20px rgba(255,0,85,.35);
          position: relative;
          animation: admPulse 2s ease-in-out infinite;
        }

        .adm-logo-wrap .anticon {
          font-size: 24px;
          color: #fff;
        }

        .adm-welcome-tag {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 3px 12px;
          background: linear-gradient(135deg, #fff0f3, #ffe4ec);
          border: 1px solid #ffd3df;
          border-radius: 999px;
          font-size: 10px;
          font-weight: 700;
          color: #c2185b;
          margin-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .adm-welcome-tag .dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #4caf50;
          box-shadow: 0 0 6px #4caf50;
          animation: admPulse 1.5s ease-in-out infinite;
        }

        /* ✅ TITLE - Chota kiya, single line */
        .adm-card-title {
          color: #1a0a10 !important;
          font-size: 20px !important;
          font-weight: 800 !important;
          margin: 0 0 4px !important;
          letter-spacing: -0.5px;
          line-height: 1.2 !important;
        }

        .adm-title-gradient {
          background: linear-gradient(135deg, #ff0055, #ff4d88);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .adm-card-subtitle {
          color: #888 !important;
          font-size: 12px !important;
          display: block;
          margin-bottom: 10px;
        }

        .adm-role-badges {
          display: flex;
          justify-content: center;
          gap: 6px;
          flex-wrap: wrap;
        }

        .adm-role-badge {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 4px 11px;
          border-radius: 999px;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.3px;
          transition: all 0.3s;
        }

        .adm-role-badge.admin {
          background: linear-gradient(135deg, #fff0f3, #ffe4ec);
          color: #ff0055;
          border: 1px solid #ffb3c8;
        }

        .adm-role-badge.dev {
          background: linear-gradient(135deg, #f3e8ff, #e9d5ff);
          color: #7c3aed;
          border: 1px solid #c4b5fd;
        }

        /* ✅ FORM - Padding aur spacing kam ki */
        .adm-form-section {
          padding: 12px 28px 18px;
        }

        .adm-form-section .ant-form-item-label {
          padding-bottom: 4px !important;
        }

        .adm-form-section .ant-form-item-label > label {
          color: #1a0a10 !important;
          font-size: 11.5px !important;
          font-weight: 700 !important;
          letter-spacing: 0.3px;
          height: auto !important;
        }

        /* ✅ Form items ke beech gap kam kiya */
        .adm-form-section .ant-form-item {
          margin-bottom: 12px;
        }

        /* ✅ Input - height kam ki */
        .adm-form-section .ant-input {
          background: #fff5f8 !important;
          border: 1.5px solid #ffe4ec !important;
          border-radius: 10px !important;
          color: #1a0a10 !important;
          padding: 9px 14px !important;
          height: auto !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          transition: all 0.3s !important;
          box-shadow: none !important;
        }

        .adm-form-section .ant-input-affix-wrapper {
          background: #fff5f8 !important;
          border: 1.5px solid #ffe4ec !important;
          border-radius: 10px !important;
          padding: 0 14px !important;
          transition: all 0.3s !important;
          box-shadow: none !important;
        }

        .adm-form-section .ant-input-affix-wrapper .ant-input {
          background: transparent !important;
          border: none !important;
          padding: 9px 0 !important;
          box-shadow: none !important;
          outline: none !important;
        }

        .adm-form-section .ant-input-affix-wrapper .ant-input:focus {
          border: none !important;
          box-shadow: none !important;
        }

        .adm-form-section .ant-input:hover,
        .adm-form-section .ant-input:focus,
        .adm-form-section .ant-input-affix-wrapper:hover,
        .adm-form-section .ant-input-affix-wrapper-focused {
          border-color: #ff0055 !important;
          background: #fff !important;
        }

        .adm-form-section .ant-input-affix-wrapper:hover .ant-input,
        .adm-form-section .ant-input-affix-wrapper-focused .ant-input {
          background: transparent !important;
        }

        .adm-form-section .ant-input-affix-wrapper-focused {
          box-shadow: 0 0 0 3px rgba(255,0,85,.08) !important;
        }

        .adm-form-section .ant-input-prefix {
          color: #ff4d88 !important;
          margin-right: 8px !important;
          font-size: 13px !important;
        }

        .adm-form-section .ant-input-suffix {
          margin-left: 8px !important;
        }

        .adm-form-section .ant-input-suffix .anticon,
        .adm-form-section .ant-input-password-icon {
          color: #ff4d88 !important;
          font-size: 13px !important;
        }

        .adm-form-section .ant-input::placeholder {
          color: #c9a8b5 !important;
          font-weight: 400 !important;
        }

        /* ✅ BUTTON - Height kam ki */
        .adm-login-btn {
          width: 100%;
          height: 44px !important;
          border: none !important;
          border-radius: 999px !important;
          background: linear-gradient(135deg, #ff0055, #ff4d88, #ff80aa) !important;
          background-size: 200% 100% !important;
          color: #fff !important;
          font-weight: 700 !important;
          font-size: 13.5px !important;
          cursor: pointer !important;
          transition: all 0.4s !important;
          box-shadow: 0 8px 20px rgba(255,0,85,.35) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 6px !important;
          margin-top: 4px;
          position: relative;
          overflow: hidden;
          letter-spacing: 0.3px;
        }

        .adm-login-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.3), transparent);
          transition: 0.6s;
        }

        .adm-login-btn:hover::before {
          left: 100%;
        }

        .adm-login-btn:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 12px 28px rgba(255,0,85,.5) !important;
          background-position: 100% 0 !important;
        }

        /* ✅ FOOTER - Compact */
        .adm-card-footer {
          padding: 0 28px 14px;
          text-align: center;
        }

        .adm-divider {
          display: flex;
          align-items: center;
          margin: 2px 0 10px;
          color: #ccc;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.5px;
        }

        .adm-divider::before,
        .adm-divider::after {
          content: '';
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, transparent, #ffe4ec, transparent);
          margin: 0 10px;
        }

        .adm-user-link {
          color: #888 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
        }

        .adm-user-link a {
          color: #ff0055;
          font-weight: 700;
          text-decoration: none;
          margin-left: 5px;
          transition: color 0.3s;
        }

        .adm-user-link a:hover {
          color: #c2185b;
          text-decoration: underline;
        }

        /* ✅ SECURITY STRIP - Compact */
        .adm-security-strip {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 10px;
          background: linear-gradient(135deg, #fff0f3, #ffe4ec);
          border-top: 1px solid #ffd3df;
          font-size: 9.5px;
          color: #c2185b;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }

        .adm-security-strip .anticon {
          color: #ff0055;
          font-size: 12px;
        }

        /* ✅ TRUST BADGES */
        .adm-trust-badges {
          display: flex;
          justify-content: center;
          gap: 6px;
          margin-top: 14px;
          flex-wrap: wrap;
        }

        .adm-trust-item {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 5px 12px;
          background: rgba(255,255,255,.2);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255,255,255,.3);
          border-radius: 999px;
          font-size: 10.5px;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.3px;
        }

        .adm-trust-item .anticon {
          color: #fff;
        }

        /* ✅ MOBILE */
        @media (max-width: 480px) {
          .adm-login-card {
            border-radius: 20px;
          }
          .adm-card-header {
            padding: 18px 20px 12px;
          }
          .adm-form-section {
            padding: 10px 20px 16px;
          }
          .adm-card-footer {
            padding: 0 20px 12px;
          }
          .adm-card-title {
            font-size: 18px !important;
          }
          .adm-logo-wrap {
            width: 50px;
            height: 50px;
            border-radius: 14px;
          }
          .adm-logo-wrap .anticon {
            font-size: 22px;
          }
          .adm-login-btn {
            height: 42px !important;
            font-size: 13px !important;
          }
        }
      `}</style>

      <div className="adm-login-page">
        <div className="adm-particles">
          {["💖", "💕", "💗", "🌹", "💝", "🌸", "❤️", "💌", "🎀", "💐"].map((e, i) => (
            <span
              key={i}
              className="adm-particle"
              style={{
                top: `${8 + (i * 9) % 82}%`,
                left: `${5 + (i * 11) % 88}%`,
                fontSize: `${20 + (i % 4) * 6}px`,
                animationDelay: `${i * 0.4}s`,
                animationDuration: `${4 + i * 0.3}s`,
              }}
            >
              {e}
            </span>
          ))}
        </div>

        <div style={{ width: "100%", maxWidth: 480, position: "relative", zIndex: 3 }}>
          <Spin spinning={isLoading} tip="Authenticating...">
            <div className="adm-login-card">
              <div className="adm-top-bar" />

              {/* HEADER */}
              <div className="adm-card-header">
                <div className="adm-logo-wrap">
                  <HeartFilled />
                </div>

                <div className="adm-welcome-tag">
                  <span className="dot" />
                  Community Rishtey
                </div>

                {/* ✅ Single line title */}
                <Title className="adm-card-title">
                  Welcome to <span className="adm-title-gradient">Admin Portal</span>
                </Title>

                <Text className="adm-card-subtitle">
                  Sign in to manage your platform
                </Text>

                <div className="adm-role-badges">
                  <span className="adm-role-badge admin">
                    <CrownOutlined /> Admin
                  </span>
                  <span className="adm-role-badge dev">
                    <CodeOutlined /> Developer
                  </span>
                </div>
              </div>

              {/* FORM */}
              <div className="adm-form-section">
                <Form layout="vertical" onFinish={submit} autoComplete="off">
                  <Form.Item
                    label="Username"
                    name="username"
                    rules={[{ required: true, message: "Please enter your username" }]}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="Enter your username"
                      autoComplete="off"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: "Please enter your password" }]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="Enter your password"
                      autoComplete="new-password"
                    />
                  </Form.Item>

                  <Form.Item style={{ marginBottom: 0 }}>
                    <Button
                      htmlType="submit"
                      className="adm-login-btn"
                      loading={isLoading}
                    >
                      <LoginOutlined /> Sign In to Dashboard
                    </Button>
                  </Form.Item>
                </Form>
              </div>

              {/* FOOTER */}
              <div className="adm-card-footer">
                <div className="adm-divider">OR</div>

                <Text className="adm-user-link">
                  Looking for user login?
                  <a href="/User_Login">Sign in here</a>
                </Text>
              </div>

              {/* SECURITY */}
              <div className="adm-security-strip">
                <SafetyCertificateOutlined />
                Secured with 256-bit SSL Encryption
              </div>
            </div>
          </Spin>

          <div className="adm-trust-badges">
            <span className="adm-trust-item">
              <SafetyCertificateOutlined /> Secure
            </span>
            <span className="adm-trust-item">
              <HeartFilled /> Trusted
            </span>
            <span className="adm-trust-item">
              <CrownOutlined /> Premium
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminLogin;